<template>
    <client-page>
        <template #subHead>
            <sub-visual sh="태성소식" bg="/images/sub/visual/sv-story.jpg" />
        </template>
        <page-section tit="태성소식" titAdd="Story">
            <story-list data-aos="fade-up" />
        </page-section>
    </client-page>
</template>

<script>

import ClientPage from "@/sets/styles/apps/client-page.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import StoryList from "@/components/client/story/story-list.vue";

import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        StoryList,

        Tit,
        Txt,
    },
    data() {
        return {
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
